module.exports = __webpack_public_path__ + "static/media/scroll3_3.554869c5.png";